import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetInboxEnrollmentForm as GetInboxEnrollmentFormQuery} from 'nutshell-graphql-types';

import GET_ENROLLMENT_FORM from '../queries/get-inbox-enrollment-form.graphql';

export const useGetEnrollmentForm = () => {
    const {
        data,
        error,
        loading: isLoading,
    } = useQuery<GetInboxEnrollmentFormQuery, Record<any, any>>(GET_ENROLLMENT_FORM, {});

    const inboxEnrollmentForm = data ? data.inboxEnrollmentForm : null;

    return {
        inboxEnrollmentForm,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    };
};
